import { useQuery } from "react-query";
import { QueryFunctionContext } from "react-query/types/core/types";

import axios from "axios";

import { PAD_SCENARIO_SERVICE_ADDRESS } from "../../../../constants/app.constants";
import { RingFence } from "../../models/ringFence";
import { GetRingFencesByScenarioKey } from "./constants";

const API_URL = `${PAD_SCENARIO_SERVICE_ADDRESS}/api/v1`;

const fetchRingFencesByScenario = async (
  keys: QueryFunctionContext
): Promise<RingFence[]> => {
  const scenarioId = keys.queryKey[1] as string;
  if (!scenarioId) {
    throw new Error("Scenario ID is required");
  }

  const response = await axios.get<RingFence[]>(
    `${API_URL}/scenario/${scenarioId}/ring-fence`
  );
  return response.data;
};

const useGetRingFencesByScenario = (scenarioId?: string) => {
  return useQuery<RingFence[]>(
    [GetRingFencesByScenarioKey, scenarioId],
    fetchRingFencesByScenario,
    {
      enabled: !!scenarioId,
      refetchOnWindowFocus: false
    }
  );
};

export default useGetRingFencesByScenario;
